import { MessageRecipientUserInfo } from '../models/api/messageDto';
import { AppUserRole } from '../models/enums/appUserRole.enum';

/** How a message addressed to a whole role reads in its "to" line. */
export const RECIPIENT_ROLE_LABELS: Partial<Record<AppUserRole, string>> = {
  [AppUserRole.Admin]: 'Administrators',
  [AppUserRole.Leader]: 'Leaders',
  [AppUserRole.User]: 'Users'
};

/**
 * The "to" line of a message or reply: role recipients by their label, then individual
 * recipients by name. A reply carries no roles — the backend already resolved who it goes to.
 */
export function formatRecipients(
  recipientUsers: MessageRecipientUserInfo[] | null | undefined,
  recipientRoles: AppUserRole[] | null | undefined = []
): string {
  const roles = (recipientRoles ?? [])
    .map(role => RECIPIENT_ROLE_LABELS[role])
    .filter((label): label is string => !!label);
  const users = (recipientUsers ?? []).map(u => u.userFullName);
  return [...roles, ...users].join(', ');
}
